export const DynamicFieldsApiUrl = '/platform/v1/accounts/dynamic-forms'

export const DynamicFieldsSections = {
  QUESTIONS: 'questions',
  DOCUMENTS: 'documents',
} as const

export const DynamicFieldsDefaultValue = {
  documents: [],
  questions: [],
}
